import * as React from "react";
import BOTable, {
  BOBody,
  BORow,
  BOCell
} from "app/components/BOComponents/BOTable/BOTable";
import Dialog from "material-ui/Dialog";
import * as FontAwesome from "react-fontawesome";

type VerificationLabelProps = {
  verified: boolean;
  loading: boolean;
  onClick: (params?: any) => any;
  children: string;
};

type VerificationDialogProps = {
  modalOpen: boolean;
  description: string;
  verifiedData: { [key: string]: string };
  onRequestClose: (params?: any) => any;
};

export const VerificationLabel = ({
  onClick,
  verified,
  loading,
  children
}: VerificationLabelProps): JSX.Element => (
  <>
    {children}
    <FontAwesome
      className={`verificationIcon ${verified || "unverified"}`}
      name={loading ? "spinner" : "shield"}
      spin={loading}
      onClick={onClick}
    />
  </>
);

export const VerificationDialog = ({
  modalOpen,
  verifiedData,
  onRequestClose,
  description
}: VerificationDialogProps): JSX.Element => {
  const body = (): JSX.Element => {
    return (
      <BOBody>
        {Object.keys(verifiedData).map((key, index) => (
          <BORow key={index}>
            <BOCell>
              <b>{key}</b>
            </BOCell>
            <BOCell>{verifiedData[key]}</BOCell>
          </BORow>
        ))}
      </BOBody>
    );
  };

  return (
    <Dialog
      title={description}
      modal={false}
      open={modalOpen}
      onRequestClose={onRequestClose}
      autoScrollBodyContent={true}
    >
      <div style={{ width: "400px" }}>
        <BOTable
          name="verification_data_table"
          body={verifiedData ? body() : null}
        />
      </div>
    </Dialog>
  );
};
